{
  "colorFormat": "פורמט צבע",
  "hex": "Hex",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
